export default {
  // 判断数组中是否包含某个元素
  contains(arr, obj) {
    let i = arr.length;
    while (i--) {
      if (arr[i] === obj) {
        return true;
      }
    }
    return false;
  },

  /**
   * 删除数组中的某个元素
   * param: arr 原数组
   * param: val 要删除的元素
   */
  removeByValue(arr, val) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] === val) {
        arr.splice(i, 1);
        break;
      }
    }
  },

  /**
   * 判断是否为数组
   * */
  isArray(o) {
    return Object.prototype.toString.call(o) === '[object Array]';
  }
}



// WEBPACK FOOTER //
// ./src/common/js/handelArray.js